var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-item-tile"},[_c('span',{staticClass:"itemText"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"itemPrice"},[_vm._v("€"+_vm._s(_vm.price))])])
}
var staticRenderFns = []

export { render, staticRenderFns }